import React from 'react';
import LoginShell from './LoginShell';
import LoginFormOversea from '../LoginFormOversea';

// Oversea login — email/password + reCAPTCHA inside the same shell as the
// standard login, replacing the bare AuthSimpleLayout card.
const LoginOverseaStitch = () => (
  <LoginShell subtitle="Sign in with your email and password.">
    <LoginFormOversea hasLabel />
  </LoginShell>
);

export default LoginOverseaStitch;
